<template>
  <div>
    <div class="page-title">Edit UGC Submission</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update UGC Submission"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.submission.page";

export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Submission.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.Submission.update(this.form);
      this.$router.push("/widgets/submission-forms");
    },
  },
};
</script>

<style></style>
